<template>
    <div class="jd-page--orderDetail">
        <div v-if="getOrderDetail">
            <appraiser-result v-if="showResult" :info="resultInfo" :appraiser="getOrderDetail.appraiser" />
            <appraiser-item v-if="!showResult" :info="appraiserInfo"> </appraiser-item>
            <goods-info :des="getOrderDetail.des || ''" :files="getOrderDetail.files" :pictures="getOrderDetail.pictures" />
        </div>
        <div v-else class="k-nodata">正在加载</div>
        <jd-tabbar />
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex"
    import AppraiserResult from "../components/appraiser-result"
    import GoodsInfo from "../components/goods-info"
    import { inXSApp} from "../../utils/wz.v2"
    export default {
        name: "order-detail",
        data(){
            return {
                id : +this.$route.query.orderId || 0
            }
        },
        computed : {
            ...mapGetters("jianding", ["getOrderDetail","CONST"]),
            ...mapGetters("timer", ["leftSecs"]),
            showResult(){
                let od = this.getOrderDetail;
                let {ORDER_STATUS_FINISHED, ORDER_STATUS_EVALUATE} = this.CONST;
                if (od.status === ORDER_STATUS_FINISHED || od.status === ORDER_STATUS_EVALUATE) {
                    return true
                }
                return false
            },
            resultInfo(){
                let {id, aid, type, definition, periods, trend, reply, isReal} = this.getOrderDetail;
                return {id, aid, type, definition, periods, trend, reply, isReal}
            },
            goodsInfo(){
                let {des, pictures, files } = this.getOrderDetail;
                return {des, pictures, files }
            },
            appraiserInfo(){
                let { appraiser } = this.getOrderDetail;
                let {aid, name, des, logo, tabs} = appraiser;
                return {aid, name, des, logo, tabs}
            }
        },
        components : {
            AppraiserResult,
            GoodsInfo,
        },
        methods : {
            ...mapActions("jianding", ["loadOrderDetail", "makeOrder"]),
            ...mapMutations("jianding", ["delOrderDetail"]),
        },
        created() {
            this.loadOrderDetail({id:this.id})
        },
        beforeDestroy() {
            this.delOrderDetail()
        }

    }
</script>

<style scoped>

</style>